import { Button, Col, Form, List, Rate, Row, notification } from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API_SERVICE from "shared/services/api-service";
interface Props{
  authorId: any
}
export default function InstructorReview(props:Props){
    const {t}: any = useTranslation();
    const [saving, setSaving] = useState(false);
    const [insReviews, setInsReviews] = useState([] as any);

    const refreshItems = () =>{
      API_SERVICE.fetchInsReviewsByUserId(props.authorId).then(({data : {data}})=>{
        setInsReviews(data);
      })
    }
    
    useEffect(() =>{
      refreshItems();
    },[]);

    return (
      <>
        <div className="modal p-0" id="addInstructorReview">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body p-4">
                <button id="closeInsReviewForm" type="button" className="close" data-dismiss="modal" style={{marginTop:'-12px'}}>&times;</button>
                {insReviews?.me && <List
                  itemLayout="vertical"
                  size="large"
                  pagination={{
                    hideOnSinglePage: true,
                    pageSize: 10,
                  }}
            
                  dataSource={[insReviews?.me]}
                  renderItem={(item: any, i: number) => (
                    <List.Item
                      key={i}
                    >
                      <List.Item.Meta
                        title={<Row gutter={20}>
                          <Col flex={'auto'}>
                            {item.user.name}&nbsp;&nbsp;
                            <Rate disabled defaultValue={item.rating}/> 
                          </Col>
                          <Col>
                              {moment(new Date(item.updated_at)).format('LLL')}
                          </Col>
                        </Row>}
                      />
                      {item.review}
                    </List.Item>
                  )}
                />}
                {
                  !insReviews?.me && <Form
                    size="large"
                    layout="vertical"
                    requiredMark={false}
                    onFinish = {(value) => {
                      setSaving(true);
                      console.log('insratingformVal',value)
                      
                      const params = {
                        rating: value.insRating,
                        review: value.insReview
                      }
                      try {
                          API_SERVICE.setInstructorRating(props.authorId,params).then((responseData) => {
                            // history.goBack();
                            let InsReviewModal = document.getElementById("closeInsReviewForm") as HTMLElement
                            InsReviewModal.click()
                            console.log('submitted.')
                            notification.success({ message: responseData.data.message });
                        }).catch((e) => {
                            notification.error({ message: API_SERVICE.handleErrors(e) });
                            setSaving(false);
                        });
                      }
                      finally {                        
                          setSaving(false);
                      }
                    }}
                  >
                    <Form.Item
                      label={t('review.label')}
                      name="insReview"
                      rules={[
                        {required: true, message: t('review.required')},
                      ]}
                    >
                      <TextArea className='br-5' rows={4}/>
                    </Form.Item>
                    <Form.Item
                      label={t('rating.label')}
                      name="insRating"
                      initialValue={1}
                      rules={[
                        {required: true, message: t('rating.required')},
                      ]}
                    >
                      <Rate allowClear={false}/>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        htmlType="submit"
                        loading={saving}
                        shape="round"
                        size={'large'}
                        className="submit btn btn-blue"
                      >
                        {t('genDict.submit')}
                      </Button>
                    </Form.Item>
                  </Form>
                }
              </div>
            </div>
          </div>
        </div>
      </>
    );
}